<template>
  <section>
    <div class="card panel-white">
      <div class="card-body">
        <label class="text-orange">
          <i class="fas fa-exclamation-circle text-orange"></i>
          {{ $t('message.my_reservations.please_confirm') }}!
        </label>
        <div>
          {{ $t('message.my_reservations.declined_booking_detail') }} {{ order.declined_order_data | declinedReason }}
        </div>
        <div class="row mt-3 no-gutters">
          <div class="col-6 pr-2">
            <a href="https://line.me/R/ti/p/%40hnk7011n"
               target="_blank"
               class="btn btn-outline-info btn-block h-100"
               v-if="orderDetail.is_no_datetime_booking === 1 || orderDetail.package_id !== null || orderDetail.subscription_id !== null || orderDetail.payment_data.method === 'bank_transfer' || orderDetail.payment_data.method === 'promptpay'">
              {{ $t('message.my_reservations.contact_admin_to_cancel') }}
            </a>
            <button class="btn btn-outline-danger btn-block h-100"
                    @click="openCancelOrderModal"
                    v-else>
              {{ $t('message.button.cancel_order') }}
            </button>
          </div>
          <div class="col-6 pl-2">
            <button class="btn btn-info btn-block h-100"
                    @click="confirmFindNewCleaner">
              {{ $t('message.button.help_me_get_any_providers') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: ['order'],
    computed: {
      ...mapGetters({
        isCanceling: 'orderDetail/getIsCanceling',
        isFindingNewCleaner: 'orderDetail/getIsFindingNewCleanerOrderDetail',
        orderDetail: 'orderDetail/getOrderDetail'
      })
    },
    methods: {
      confirmFindNewCleaner () {
        this.$parent.confirmFindNewCleaner()
      },
      openCancelOrderModal () {
        this.$parent.openCancelOrderModal()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/FineNewProvider.vue